class PropertyResponse {
    constructor( response ) {
        this.response = response;
    }
}

export default PropertyResponse;
